module.exports = __webpack_public_path__ + "a092c0cdc48b25c0b90d78781fd524bc.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-88.png
// module id = 151
// module chunks = 0